/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {Karen} from "../../Karen";
import {KarenParsedGameData} from "../../server/data/KarenParsedGameData";
import {KarenSymbol} from "../../symbol/KarenSymbol";
import {ScatterAnimation} from "../../view/ScatterAnimation";
import {KarenSoundManager} from "../../sound/KarenSoundManager";
import {KarenSoundConfig} from "../../sound/KarenSoundConfig";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin(): boolean {
        const data: KarenParsedGameData = Karen.model.parsedGameData;
        return data.mode != GameMode.FREESPIN && data.nextMode === GameMode.FREESPIN;
    }

    protected async createWinAnimation(): Promise<any> {
        const tl: TimelineLite = gsap.timeline();
        const scatterAnim: ScatterAnimation = new ScatterAnimation("scatter");
        tl.add(scatterAnim.playTriggerAnimation("trigger"));
        tl.add(() => {
            KarenSoundManager.playSoundEffect(KarenSoundConfig.SCATTER_TRIGGER);
        },0);
        tl.to(this, {duration: 0.1}); // Add this line because the Karen server didn't give scatterPositions and the empty tl doesn't continue the promise chain.
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            Karen.freespinIntro.show(() => {
                Karen.keypadPlugin.setZeroBetSpinCounter(Karen.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}
